import React from 'react';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import SubscriptionGate from './SubscriptionGate';
import TrialBanner from './TrialBanner';
import { useUserProfile } from '../../contexts/UserContext';

/**
 * MaintenanceScreen — Exibida quando config.manutencao === true
 * Super Admin nunca vê esta tela.
 */
function MaintenanceScreen({ message }) {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: 'calc(100vh - 80px)',
      padding: 32,
      fontFamily: 'var(--font)',
    }}>
      <div style={{
        maxWidth: 460,
        width: '100%',
        textAlign: 'center',
        padding: '56px 32px',
        background: 'var(--white)',
        borderRadius: 'var(--radius)',
        border: '1px solid var(--border)',
        boxShadow: '0 8px 32px rgba(0,0,0,0.06)',
      }}>
        <div style={{
          width: 80, height: 80, borderRadius: 20,
          background: 'linear-gradient(135deg, #DBEAFE, #BFDBFE)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          margin: '0 auto 24px', fontSize: '2.2rem',
        }}>
          🔧
        </div>

        <h2 style={{
          fontSize: '1.3rem', fontWeight: 700,
          color: 'var(--text)', margin: '0 0 12px',
        }}>
          Sistema em Manutenção
        </h2>

        <p style={{
          fontSize: '0.92rem', color: 'var(--text-muted)',
          lineHeight: 1.6, margin: 0,
        }}>
          {message}
        </p>

        <div style={{
          marginTop: 32, padding: '12px 20px',
          background: 'var(--surface)', borderRadius: 10,
          fontSize: '0.78rem', color: 'var(--text-muted)',
        }}>
          Seus dados estão seguros. O acesso será restaurado automaticamente quando a manutenção for concluída.
        </div>
      </div>
    </div>
  );
}

export default function DashboardLayout({ title, subtitle, topbarActions, children }) {
  const { isMaintenanceMode, maintenanceMessage, isSuperAdmin } = useUserProfile();

  return (
    <div style={{ fontFamily: 'var(--font)', color: 'var(--text)', background: 'var(--surface)', minHeight: '100vh' }}>
      <Sidebar />
      <div style={{
        marginLeft: 'var(--sidebar-w)',
        minHeight: '100vh',
        transition: 'margin-left 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
      }}>
        <Topbar title={title} subtitle={subtitle}>
          {topbarActions}
        </Topbar>
        <div className="dash-content" style={{ padding: '28px 32px' }}>
          {/* Banner de manutenção para super admin */}
          {isSuperAdmin && isMaintenanceMode && (
            <div style={{
              display: 'flex', alignItems: 'center', gap: 10,
              padding: '10px 16px', marginBottom: 16, borderRadius: 10,
              background: 'rgba(239,68,68,0.06)', border: '1px solid rgba(239,68,68,0.15)',
              fontSize: '0.82rem', fontWeight: 600, color: '#DC2626',
            }}>
              🔧 Modo manutenção ativo — apenas Super Admins podem acessar o sistema.
            </div>
          )}

          {isMaintenanceMode && !isSuperAdmin ? (
            <MaintenanceScreen message={maintenanceMessage} />
          ) : (
            <>
              <TrialBanner />
              <SubscriptionGate>
                {children}
              </SubscriptionGate>
            </>
          )}
        </div>
      </div>
      <style>{`
        @media(max-width:768px){
          .dash-content{padding:16px 12px!important}
        }
      `}</style>
    </div>
  );
}